<header class="header">
  <div routerLink="/" class="header-logo">
    <img src="assets/shared/img/wappen.svg" />
    <div class="header-logo-text">
      <span class="header-logo-text-first">{{ 'header-mini.title-1' | transloco }} <br />{{ 'header-mini.title-2' | transloco }}</span>
      <span class="header-logo-text-second">{{ 'header-mini.title-3' | transloco }}</span>
      <span class="header-logo-text-third">{{ 'header-mini.title-4' | transloco }}</span>
    </div>
  </div>
  <app-i18n class="i18n"></app-i18n>
  <app-user-card class="app-user-card"></app-user-card>
</header>
